/**
 * Configuration(s) for R2B reward
 */ export var R2B_REWARD_CONFIG_220725 = 'R2B_REWARD_CONFIG_220725';
